import { useContext, useState } from "react";
import { DataContext } from "../../context/data-context";
import { UtilityContext } from "../../context/util-context";
import SidebarButton from "../UI/SidebarButton";
import { useLocation } from "react-router-dom";
import { toTitleCase } from "../../util/format-text";
import { FaCarCrash, FaUserCircle } from "react-icons/fa";
import {
  MdAddChart,
  MdBolt,
  MdBookmarks,
  MdChat,
  MdConstruction,
  MdDirectionsCar,
  MdDiscount,
  MdEditCalendar,
  MdHistory,
  MdLocationOn,
  MdMenu,
  MdOutgoingMail,
  MdPayments,
} from "react-icons/md";
import { BiSolidMegaphone } from "react-icons/bi";
import Modal from "../UI/Modal";
import { GiTowTruck } from "react-icons/gi";

const menu = [
  "general",
  "bookings",
  "payments",
  "expenses",
  "customers",
  "vehicles",
  "partners",
  "employees",
];

const icons = [
  { name: "applications", icon: MdDirectionsCar },
  { name: "audits", icon: MdHistory },
  { name: "charging", icon: MdBolt },
  { name: "claims", icon: FaCarCrash },
  { name: "coupons", icon: MdDiscount },
  { name: "announcements", icon: BiSolidMegaphone },
  { name: "locations", icon: MdLocationOn },
  { name: "maintenance", icon: MdConstruction },
  { name: "opportunities", icon: MdAddChart },
  { name: "billing", icon: MdPayments },
  { name: "quotes", icon: MdOutgoingMail },
  { name: "repossessions", icon: GiTowTruck },
  { name: "service", icon: MdEditCalendar },
  { name: "support", icon: MdChat },
  { name: "tolls", icon: MdBookmarks },
];

/** ========================================================================
 * * MenuBar Component
 * Renders the top navigation bar in small viewports.
 * ========================================================================== */

export default function Sidebar() {
  const location = useLocation();
  const { navigate } = useContext(UtilityContext);
  const { admin } = useContext(DataContext);

  // Initialize States
  const [show, setShow] = useState(false);

  // Get page address from url
  const selected = location.pathname.slice(1).split("/")[0] || "general";

  /* ======================= SELECTION HANDLER ======================= */
  const selectionHandler = (selected, e) => {
    navigate(`/${selected.toLowerCase()}`, e);
    setShow(false);
  };

  /* ======================= ICON CLASSES ======================= */
  const iconClasses = (icon) => {
    let classes = "text-3xl icon";
    if (icon === selected) classes += " text-yellow-600";
    return classes;
  };

  return (
    <div className="relative mb-2 clickable">
      <div className="flex items-center px-4 rounded-md lg:hidden bg-stone-900 text-stone-400">
        <MdMenu
          className="text-2xl text-stone-400"
          onClick={() => setShow(!show)}
        />
        <p
          onClick={() => setShow(!show)}
          className="w-full py-2 text-sm text-center"
        >
          {toTitleCase(selected)}
        </p>
        {admin?.photo ? (
          <img
            src={admin.photo}
            className="w-8 h-8 rounded-full"
            onClick={() => navigate(`/employees/info?id=${admin?.id}`)}
          />
        ) : (
          <FaUserCircle
            className="w-6 h-6 text-yellow-600"
            onClick={() => navigate(`/employees/info?id=${admin?.id}`)}
          />
        )}
      </div>
      <Modal open={show} setOpen={() => setShow(false)}>
        <div className="modal z-50 grid gap-6 lg:hidden w-[90vw] p-6">
          <div className="grid grid-cols-5 mb-4 rounded-lg gap-x-2 gap-y-6 justify-items-center">
            {icons.map(({ name, icon: IconComponent }) => (
              <IconComponent
                key={name}
                className={iconClasses(name)}
                onClick={(e) => selectionHandler(name, e)}
              />
            ))}
          </div>
          <hr className="hr" />
          <div className="grid grid-cols-2 gap-6">
            {menu.map((item, index) => (
              <SidebarButton
                key={index}
                title={item}
                selected={selected.length === 0 ? "general" : selected}
                onClick={(e) => selectionHandler(item, e)}
              />
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
}
